import { loginReq, rememberLoginReq, clearRememberReq } from "../Api/index";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setActionsControleR, setCaptchR } from "../../../General/Store/GeneralSlice";
import { customApi } from "../../../CustomHoock/CustomApi";
import decClims from "../../../utils/decClaims";
import axios from "axios";
import { baseApiUrl } from "../../../env";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";

/*====================== shared success handler ==============================*/
const handleAuthSuccess = (data, dispatch, navigate, handleSuccess) => {
  if (!data?.data?.data?.needCaptcha) {
    const claims = data?.data?.data?.claims || [];
    const collectionId = data?.data?.data?.collectionId;
    const secureClaims = data?.data?.data?.secureClaims;

    const resultClaime = decClims(secureClaims);
    Cookies.set("collectionId", collectionId, { expires: 7 });
    localStorage.setItem("claims", JSON.stringify(resultClaime));

    const userInfo = {
      token: data?.data?.data?.token,
      userId: data?.data?.data?.id,
      personId: data?.data?.data?.personId,
      userRole: data?.data?.data?.userRoles,
      userLogin: {
        fristName: data?.data?.data?.firstName,
        lastName: data?.data?.data?.lastName,
      },
      userImageUr: data?.data?.data?.userImageUrl,
    };

    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    navigate("/dashboard/overview", { replace: true });

    const actionDetails = {};
    if (claims.length > 0) {
      claims.forEach((element) => {
        actionDetails[element.controllerName] = element.actionDetails;
      });
      dispatch(setActionsControleR(actionDetails));
    }

    handleSuccess?.("ورود موفق");
  } else {
    dispatch(setCaptchR(true));
  }
};

/*====================== Login ==============================*/
// const useLoginReq = (handleSuccess, handleFailed) => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   return useMutation(
//     (data) => loginReq(data),
//     {
//       onSuccess: (data) => {
//         handleAuthSuccess(data, dispatch, navigate, handleSuccess);
//       },
//       onError: (error) => {

//         const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
//         if (errorList) {
//           errorList.forEach((errorListItem) => {
//             const element = errorListItem.resourceKeys;
//             element.forEach((errorText) => handleFailed?.(errorText));
//           });
//         } else {
//           handleFailed?.("خطایی رخ داده است");
//         }
//       },
//     }
//   );
// };

const useLoginReq = (handleSuccess, handleFailed) => {
  // const queryClient = useQueryClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (body) => loginReq(body),
    onSuccess: (data) => {
      handleAuthSuccess(data, dispatch, navigate, handleSuccess);
    }
    ,
    onError: (error) => {
      // handleFailed()
      // const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
      // if (errorList) {
      //   errorList.forEach((errorListItem) => {
      //     const element = errorListItem.resourceKeys;
      //     element.forEach((errorText) => handleFailed?.(errorText));
      //   });
      // } else {
      //   // handleFailed?.("خطایی رخ داده است");
      // }
    },
  })
}

/*====================== Remember Login ==============================*/
const useRememberLoginReq = (handleSuccess, handleFailed) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return useMutation(
    () => rememberLoginReq(),
    {
      onSuccess: (data) => {
        handleAuthSuccess(data, dispatch, navigate, handleSuccess);
      },
      onError: (error) => {
        const errorList = error?.response?.data?.resourceKeyResult?.resourceKeyList;
        if (errorList) {
          errorList.forEach((errorListItem) => {
            const element = errorListItem.resourceKeys;
            element.forEach((errorText) => handleFailed?.(errorText));
          });
        } else {
          handleFailed?.("خطایی رخ داده است");
        }
      },
    }
  );
};

/*================================ Log out ==============================*/
const useGetLogout = () => {
  const navigate = useNavigate();

  return useMutation(
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/Authentication/Logout",
        reactQuery: "mutate",
        withCredentials: true,
      }),
    {
      onSuccess: () => {
        localStorage.removeItem("claims");
        localStorage.removeItem("userInfo");
        navigate("/");
      },
    }
  );
};

const getLoginPage = async (id) => {
  const response = await axios.get(`${baseApiUrl}/api/v1/LoginPage/GetLoginPage`, {
    params: { id },
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
    withCredentials: true,
  });
  return response.data?.data;
};

const useClearRememberReq = (handleSuccess, handleFailed) =>
  useMutation(() => clearRememberReq(), {
    onSuccess: () => handleSuccess?.("ورود خودکار غیرفعال شد"),
    onError: (err) =>
      handleFailed?.(err?.response?.data?.message || "خطا در غیر فعال کردن ورود خودکار"),
  });

export {
  useLoginReq,
  useRememberLoginReq,
  useGetLogout,
  getLoginPage,
  useClearRememberReq
};
